import { TaskType } from '../../linkedTasks/serverApi/types/LinkedTask';
import { ISiteNameWithId } from '../../siteManagement/serverApi/types/ISiteNameWithId';
import { FlowParameterRunInfo,IExplorableItemTypeInfo, INamedItemInfo, IScheduledItemInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { FlowRunError } from '../serverApi/types/FlowRunError';
import { FlowOutputStepInfo } from './FlowOutputStepInfo';

export interface RunFlowTaskInfo extends INamedItemInfo, IScheduledItemInfo, IExplorableItemTypeInfo<'runFlowTask'>, FlowParameterRunInfo {
  flow?: INamedItemInfo;
  flowId?: string;
  priority: number;
  lastRunAt?: Date;
  runNextAt?: Date;
  site: ISiteNameWithId;
  flowOutputSteps?: FlowOutputStepInfo[];
  runAllOutputs?: boolean;
  isRunAllIncremental?: boolean;
  suspended?: boolean;
  flowRunErrors?: FlowRunError[];
  status?: RunFlowTaskStatus;
  stepNumber?: number;
  totalSteps?: number;
  taskType?: TaskType;
  linkedTaskId?: string;
}

export enum RunFlowTaskStatus {
  Suspended = 'SUSPENDED',
  Failed = 'FAILED',
  Succeeded = 'SUCCESS',
  InProgress = 'INPROGRESS',
  Scheduled = 'SCHEDULED'
}
